var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoaching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.317,
    height: 101.527,
    viewBox: "0 0 105.317 101.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-coaching",
    transform: "translate(-607.662 -859.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-coaching-2",
    "data-name": "icon-coaching",
    d: "M78.463,33.411c9.421,16.7,16.9,34.853,11.333,44.166-5.5,9.314-24.128,9.854-42.022,9.274C29.947,86.2,12.783,84.431,5.094,73.8c-7.757-10.7-6.1-30.252,2.3-46.3S31.029-1.147,44.289.166C57.616,1.48,69.042,16.715,78.463,33.411Z",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 622.679, 859.357)",
    fill: "#5cb85c",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    id: "hosting",
    transform: "translate(639 894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4069",
    "data-name": "Group 4069",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4068",
    "data-name": "Group 4068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14668",
    "data-name": "Path 14668",
    d: "M427.478,341.333a.812.812,0,1,0,.813.812A.813.813,0,0,0,427.478,341.333Z",
    transform: "translate(-394.169 -315.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14669",
    "data-name": "Path 14669",
    d: "M384.812,341.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,384.812,341.333Z",
    transform: "translate(-354.753 -315.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14670",
    "data-name": "Path 14670",
    d: "M45.1,170.667a2.437,2.437,0,1,0,2.437,2.437A2.44,2.44,0,0,0,45.1,170.667Zm0,3.25a.812.812,0,1,1,.812-.812A.813.813,0,0,1,45.1,173.917Z",
    transform: "translate(-39.417 -157.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14671",
    "data-name": "Path 14671",
    d: "M45.1,298.667a2.437,2.437,0,1,0,2.437,2.437A2.44,2.44,0,0,0,45.1,298.667Zm0,3.25a.812.812,0,1,1,.812-.812A.813.813,0,0,1,45.1,301.917Z",
    transform: "translate(-39.417 -275.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14672",
    "data-name": "Path 14672",
    d: "M299.478,341.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,299.478,341.333Z",
    transform: "translate(-275.918 -315.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14673",
    "data-name": "Path 14673",
    d: "M342.145,341.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,342.145,341.333Z",
    transform: "translate(-315.336 -315.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14674",
    "data-name": "Path 14674",
    d: "M39,7.312V4.062A4.068,4.068,0,0,0,34.934,0H4.062A4.068,4.068,0,0,0,0,4.062v3.25a4.047,4.047,0,0,0,1.651,3.25A4.047,4.047,0,0,0,0,13.811v3.25a4.047,4.047,0,0,0,1.651,3.25A4.047,4.047,0,0,0,0,23.56v3.25a4.068,4.068,0,0,0,4.062,4.062H14.624V32.5h-.812a.813.813,0,0,0-.812.812v.812h-.812a.813.813,0,0,0-.812.812v.812H4.062a.812.812,0,0,0,0,1.625h7.312v.812a.813.813,0,0,0,.812.812h6.5a.813.813,0,0,0,.812-.812v-.812H26.81a.812.812,0,1,0,0-1.625H19.5v-.812a.813.813,0,0,0-.812-.812h-.812v-.812a.813.813,0,0,0-.812-.812h-.812V30.872H34.934A4.068,4.068,0,0,0,39,26.81V23.56a4.047,4.047,0,0,0-1.651-3.25A4.047,4.047,0,0,0,39,17.061v-3.25a4.047,4.047,0,0,0-1.651-3.25A4.047,4.047,0,0,0,39,7.312ZM17.061,35.747h.812v1.625H13V35.747h.812a.813.813,0,0,0,.812-.812v-.812h1.625v.812A.813.813,0,0,0,17.061,35.747ZM37.371,23.56v3.25a2.44,2.44,0,0,1-2.437,2.437H4.062A2.44,2.44,0,0,1,1.625,26.81V23.56a2.44,2.44,0,0,1,2.437-2.437H34.934A2.44,2.44,0,0,1,37.371,23.56Zm0-9.749v3.25A2.44,2.44,0,0,1,34.934,19.5H4.062a2.44,2.44,0,0,1-2.437-2.437v-3.25a2.44,2.44,0,0,1,2.437-2.437H34.934A2.44,2.44,0,0,1,37.371,13.811Zm0-6.5a2.44,2.44,0,0,1-2.437,2.437H4.062A2.44,2.44,0,0,1,1.625,7.312V4.062A2.44,2.44,0,0,1,4.062,1.625H34.934a2.44,2.44,0,0,1,2.437,2.437v3.25Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14675",
    "data-name": "Path 14675",
    d: "M299.478,85.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,299.478,85.333Z",
    transform: "translate(-275.918 -78.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14676",
    "data-name": "Path 14676",
    d: "M342.145,85.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,342.145,85.333Z",
    transform: "translate(-315.336 -78.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14677",
    "data-name": "Path 14677",
    d: "M384.812,85.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,384.812,85.333Z",
    transform: "translate(-354.753 -78.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14678",
    "data-name": "Path 14678",
    d: "M299.478,213.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,299.478,213.333Z",
    transform: "translate(-275.918 -197.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14679",
    "data-name": "Path 14679",
    d: "M427.478,85.333a.812.812,0,1,0,.813.812A.813.813,0,0,0,427.478,85.333Z",
    transform: "translate(-394.169 -78.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14680",
    "data-name": "Path 14680",
    d: "M384.812,213.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,384.812,213.333Z",
    transform: "translate(-354.753 -197.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14681",
    "data-name": "Path 14681",
    d: "M342.145,213.333a.812.812,0,1,0,.812.812A.813.813,0,0,0,342.145,213.333Z",
    transform: "translate(-315.336 -197.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14682",
    "data-name": "Path 14682",
    d: "M427.478,213.333a.812.812,0,1,0,.813.812A.813.813,0,0,0,427.478,213.333Z",
    transform: "translate(-394.169 -197.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14683",
    "data-name": "Path 14683",
    d: "M45.1,42.667A2.437,2.437,0,1,0,47.542,45.1,2.44,2.44,0,0,0,45.1,42.667Zm0,3.25a.812.812,0,1,1,.812-.812A.813.813,0,0,1,45.1,45.917Z",
    transform: "translate(-39.417 -39.417)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoaching);
export default __webpack_public_path__ + "static/media/icon-coaching.b1ff2541f3e5a9b887fa0943700b088d.svg";
export { ForwardRef as ReactComponent };